import { FC } from 'react'
import CustomSelect from '../../UI/CustomSelect/CustomSelect'
import styles from '../EditClaimCardMainInformation.module.css'
import { segments } from '../../../constants/constants'

interface AdditionalInformationSectionProps {
  values: any
  handleChange: any
  setFieldValue: (field: string, value: any) => void
}

export const AdditionalInformationSection: FC<AdditionalInformationSectionProps> = ({
  values,
  handleChange,
  setFieldValue,
}) => {
  return (
    <div className={styles.sectionBlock}>
      <div className={styles.sectionTitle}>Дополнительная информация</div>
      <div className={styles.sectionContent}>
        <div className={styles.statusBlock}>
          <div className={styles.leftBlock}>Сегмент</div>
          <div className={styles.rightDateBlock}>
            <div className={styles.segmentInputBlock}>
              <CustomSelect
                name='segment'
                options={segments}
                value={values.segment}
                onChangeOption={(option) => setFieldValue('segment', option)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
